import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import * as UI from 'ui'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import { OnNavigatePipeline } from '@morningtrain/react-navigation'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'
import TotalRevenueEconomyWidget from 'widgets/economy/TotalRevenueEconomyWidget'
import RevenueByLocationSmartview from 'widgets/economy/smartviews/RevenueByLocationSmartview'
import AverageBasketSizeEconomyWidget from 'widgets/economy/AverageBasketSizeEconomyWidget'
import GuestCountEconomyWidget from 'widgets/economy/GuestCountEconomyWidget'
import FoodsToDrinksRatioEconomyWidget from 'widgets/economy/FoodsToDrinksRatioEconomyWidget'
import RestaurantToGoRatioEconomyWidget from 'widgets/economy/RestaurantToGoRatioEconomyWidget'
import RestaurantChecklistsEconomyWidget from 'widgets/economy/RestaurantChecklistsEconomyWidget'
import TrendingProductsWidget from 'widgets/economy/TrendingProductsWidget'
import TotalOverviewWidget from 'widgets/economy/TotalOverviewWidget'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Translator } from '@morningtrain/react-translations'
import PeriodFilterSyncedWithPage from '../../../support/filters/PeriodFilterSyncedWithPage'
import DailyReportWidget from 'widgets/economy/DailyReportWidget'
import {Env} from "@morningtrain/helpers";

export default function Economy (props) {
  const appServer = Env.get('globals.app_server');
  let categories = ['drinks', 'burgers', 'sides', 'dips'];

  if (appServer === 'Kcal') {
    categories = ['sandwich', 'salat', 'drinks', 'extra'];
  }

  return (
    <AdminPageWithSmartview defaultSmartviewSize='sm'>

      <Translator namespace="economy.pages.overview">
        <UI.PageHeader title={<TranslatedTitle/>}>
          <PeriodFilterSyncedWithPage selectors={['yesterday', 'today', 'this_week', 'this_month', 'this_year']}/>
        </UI.PageHeader>
      </Translator>

      <UI.CardGroup>

        <WhenDeviceNotAuthorized>

          <Can permission={Permissions.DASHBOARD_FULL}>

            <OnNavigatePipeline>
              <MountSmartviewOnPipe smartview={<RevenueByLocationSmartview />} replace />
            </OnNavigatePipeline>

            <UI.FlexGrid responsive={{ md: 3 }}>
              <TotalRevenueEconomyWidget />
              <AverageBasketSizeEconomyWidget />
              <GuestCountEconomyWidget />
            </UI.FlexGrid>

            <UI.FlexGrid responsive={{ md: 3 }}>
              <FoodsToDrinksRatioEconomyWidget />
              <RestaurantToGoRatioEconomyWidget />
              <RestaurantChecklistsEconomyWidget />
            </UI.FlexGrid>

            <UI.FlexGrid responsive={{ md: 2 }}>
              {categories.map((category) => {
                return (
                  <TrendingProductsWidget product={category} />
                );
              })}
            </UI.FlexGrid>

            <TotalOverviewWidget />
            <DailyReportWidget />

          </Can>

        </WhenDeviceNotAuthorized>

      </UI.CardGroup>
    </AdminPageWithSmartview>
  )
}
